import { GoalsWithStatus } from '@components';
import { GoalStore } from '@stores';

interface GoalCardView {
  goalsWithProgress: GoalsWithStatus;
  jailCards: number;
  goalResponses: GoalResponseView[];
  participantActivities: ParticipantActivities;
}

export interface GoalResponseView {
  questionText: string;
  responseText: string;
}

export interface ParticipantActivity {
  id: number;
  activityId: number;
  timeframeId: number;
  cohortUserId: number;
  goalId: number;
  dateStamp: string; // ISO date string, e.g., "2025-07-07"
  duration: number;
  name: string;
}

export interface ParticipantActivities {
  [cohortUserId: string]: ParticipantActivity[];
}

export class AdminGoalCardViewCreator {
  constructor(private readonly goalStore: GoalStore = new GoalStore()) {}

  public async CreateView(cohortUserId: number): Promise<GoalCardView> {
    // Get the content from the API
    const content = await this.goalStore.AdminReadByCohortUserId(cohortUserId);
    const goals = content.result.goals;
    const progress = content.result.progress;
    const goalsWithProgress = {
      goals: goals,
      progress: progress,
    };
    const jailCards = content.result.participantJailCards;
    const goalResponses = content.result.goalResponses;
    let finalGoalResponses: GoalResponseView[] = [];

    // For each goalResponse, create a view object
    for (const goalResponse of goalResponses) {
      const questionText = goalResponse.questionText;
      const responseText = goalResponse.responseText;

      // Create the view object
      const goalResponseView: GoalResponseView = {
        questionText: questionText,
        responseText: responseText,
      };

      // Add to the final array
      finalGoalResponses.push(goalResponseView);
    }

    // Participant activities
    const participantActivities: ParticipantActivities = content.result.participantActivities;

    // Return the view
    return {
      goalsWithProgress: goalsWithProgress,
      jailCards: jailCards,
      goalResponses: finalGoalResponses,
      participantActivities: participantActivities,
    };
  }
}
